import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { PR_ROLE_OPTIONS, PR_ROLE_VALUES } from 'utils/enums'
import { EXECUTOR_SCHEMA } from 'lib/probate/estate-questionnaire-schema'
import { Address as AddressType } from 'lib/models/address'

import ContactDetailsFields from '../../components/contact-details-fields'
import {
  getPersonalRepresentativeConfig,
  PERSONAL_REPRESENTATIVE_TYPE,
} from '../../constants'
import { useAttributesRole } from '../../shared-contacts/roles'
import SharedPeopleSection from '../../shared-contacts/shared-people-section'

type Props = {
  hasWill?: boolean
}

const Executors = ({ hasWill }: Props) => {
  const config = getPersonalRepresentativeConfig({ hasWill })
  const isAdministrator =
    config.personalRepresentativeType !== PERSONAL_REPRESENTATIVE_TYPE.EXECUTOR

  const role = useAttributesRole({
    isMember: ({ personalRepresentativeType }) =>
      personalRepresentativeType === config.personalRepresentativeType,
    given: {
      personalRepresentativeType: config.personalRepresentativeType,
      isPersonalRepresentative: true,
      ...(isAdministrator && {
        personalRepresentativeRole: PR_ROLE_VALUES.acting,
      }),
    },
    taken: {
      personalRepresentativeType: null,
      isPersonalRepresentative: false,
      personalRepresentativeRole: null,
    },
  })

  return (
    <SharedPeopleSection
      heading={config.heading}
      type={config.cardType}
      addLabel={config.addButtonLabel}
      role={role}
      schema={EXECUTOR_SCHEMA}
      renderFields={({ handleSave, values, onUnsavedAddressChange }) => (
        <>
          {/* administrators are always acting */}
          {!isAdministrator && (
            <Grid.Item span={12}>
              <InputFloating
                name="personalRepresentativeRole"
                label="Role"
                component="select"
                options={PR_ROLE_OPTIONS}
                handleSave={handleSave}
              />
            </Grid.Item>
          )}
          <ContactDetailsFields
            address={(values.address as AddressType) ?? null}
            handleSave={handleSave}
            onUnsavedAddressChange={onUnsavedAddressChange}
          />
        </>
      )}
    />
  )
}

export default Executors
